/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tabartifacts1Inputs */

const en_tabartifacts1 = /** @type {(inputs: Tabartifacts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artifacts`)
};

const pt_tabartifacts1 = /** @type {(inputs: Tabartifacts1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentos gerados`)
};

/**
* | output |
* | --- |
* | "Artifacts" |
*
* @param {Tabartifacts1Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const tabartifacts1 = /** @type {((inputs?: Tabartifacts1Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tabartifacts1Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tabartifacts1(inputs)
	return pt_tabartifacts1(inputs)
});
export { tabartifacts1 as "tabArtifacts" }